/**
 * @param {string | undefined} name Snake cased string to be converted to spaced with title Case
 * @return {string | undefined} String Without underscore and Each initial character of word capitalize
 */
export function toTitleCaseWithSpace(name: string): string | undefined {
  return name
    ?.split("_")
    .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
    .join(" ");
}
